import { defineEvent } from '../types/event';
export var DISCOUNT_CODE_APPLY = defineEvent({
    platforms: [
        {
            name: 'Heap',
            alias: 'cart_discount_code'
        }
    ]
});
